export default __webpack_public_path__ + "static/single-step-a00892c7d86cb744264923ae1c0fea0fbe165e2c32f248b6dd35ca95253f685c.png";